import { useState } from 'react'
import priceIcon1 from '../assets/icons/priceicon1.svg'
import priceIcon2 from '../assets/icons/priceicon2.svg'
import priceIcon3 from '../assets/icons/priceicon3.svg'
import Slider from './Slider'
import './styles/pricing.css'

const pricingCards = [
    {
        icon:priceIcon1,
        type:'Basic',
        price:'Free',
        priceSecond:'Free',
        desc:`If you have a valid university email, 
        you get a discount on us. Invest in your future!`,
        features:[
            'All Operating Supported',
            'Great Interface',
            'Allows encryption',
            'Face recognized system',
            '24/7 Full support'
        ]

    },
    {
        icon:priceIcon2,
        type:'Professional',
        price:'$9,99',
        priceSecond:'$12,99',
        desc:`If you have a valid university email, 
        you get a discount on us. Invest in your future!`,
        features:[
            'All Operating Supported',
            'Great Interface',
            'Allows encryption',
            'Face recognized system',
            '24/7 Full support'
        ]

    },
    {
        icon:priceIcon3,
        type:'Premium',
        price:'$24,99',
        priceSecond:'$26,99',
        popular:true,
        desc:`If you have a valid university email, 
        you get a discount on us. Invest in your future!`,
        features:[
            'All Operating Supported',
            'Great Interface',
            'Allows encryption',
            'Face recognized system',
            '24/7 Full support'
        ]

    },
]
const pricingCardsMobile = [
    {
        icon:priceIcon3,
        type:'Premium',
        price:'$24,99',
        priceSecond:'$26,99',
        popular:true,
        desc:`If you have a valid university email, 
        you get a discount on us. Invest in your future!`,
        features:[
            'All Operating Supported',
            'Great Interface',
            'Allows encryption',
            'Face recognized system',
            '24/7 Full support'
        ]

    },
    {
        icon:priceIcon1,
        type:'Basic',
        price:'Free',
        priceSecond:'Free',
        desc:`If you have a valid university email, 
        you get a discount on us. Invest in your future!`,
        features:[
            'All Operating Supported',
            'Great Interface',
            'Allows encryption',
            'Face recognized system',
            '24/7 Full support'
        ]

    },
    {
        icon:priceIcon2,
        type:'Professional',
        price:'$9,99',
        priceSecond:'$12,99',
        desc:`If you have a valid university email, 
        you get a discount on us. Invest in your future!`,
        features:[
            'All Operating Supported',
            'Great Interface',
            'Allows encryption',
            'Face recognized system',
            '24/7 Full support'
        ]

    },
]

export default function Pricing() {
    const [checked,setChecked] = useState(true)

  return (
    <div id='pricing' className='pricing'>
        <div className="pricing__body">
            <div className="pricing__head">
                <div className="pricing__label">
                    subscription plans
                </div>
                <div className='pricing__title'>
                  Simple Pricing
                </div>
                <div className='pricing__row'>
                    <span className='pricing__row-key'>Monthly</span>
                    <div 
                    className={checked 
                    ? 
                    'pricing__checkbox' 
                    : 
                    'pricing__checkbox unchecked'}
                    >
                        <label htmlFor="pricing-checkbox"></label>
                        <input 
                        onChange={() => setChecked(state => !state)} 
                        type="checkbox" 
                        checked={checked} 
                        id="pricing-checkbox" />
                    </div>
                    <span>Annually Save 30%</span>
                </div>
            </div>
            <div className="pricing__cards">
                {pricingCards.map((card,index) => {
                    return(
                        <div className={`pricing__card card${index}`} key={index}>
                            {
                                card?.popular
                                ?
                                <div className='pricing__card-label'>Most Popular</div>
                                :
                                <></>
                            }
                            <div className={'pricing__card-img' + index}>
                                <img src={card.icon} alt={card.type}/>
                            </div>
                            <div className='pricing__card-type'>
                                {card.type}
                            </div>
                            <div className='pricing__card-price'>
                                {checked ? card.price : card.priceSecond} 
                            </div>
                            <div className='pricing__card-text'>
                                {card.desc}
                            </div>
                            <ul className='pricing__card-features'>
                                {card.features.map((feature) => {
                                    return (
                                        <li key={feature} className='pricing__card-feature'>
                                            {feature}
                                        </li>
                                    )
                                })}
                            </ul>
                            {
                                card?.popular
                                ?
                                <button className='pricing__card-blue-btn'>GET STARTED</button>
                                :
                                <button className='pricing__card-white-btn'>GET STARTED</button>
                            }
                        </div>
                    )
                })}
            </div>
            <div className='pricing-mobile__slider'>
                <Slider checked={checked} items={pricingCardsMobile}/>
            </div>
        </div>
    </div>
  )
}
